import { h, Component } from 'preact';
import Loadable from 'react-loadable';
import { isMobileRequest } from '../../utils/CommonHelper.js';

const VapDesktop = Loadable({
    loader: () => import('../../../../q-cars/src/containers/VAP/desktop/vap.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let SnbDesktop = loaded.default;
        return <SnbDesktop {...props} />;
    }
});

const VapMsite = Loadable({
    loader: () => import('../../../../q-cars/src/containers/VAP/vap.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let SnbMsite = loaded.default;
        return <SnbMsite {...props} />;
    }
});

export default class VAP extends Component {
	render(props) {
	 	return isMobileRequest() ? <VapMsite {...props}/> : <VapDesktop {...props}/>;
    }
}


// WEBPACK FOOTER //
// ../q-cars/src/containers/VAP/index.js